import React from 'react';
import './MeetingCard.css';

export interface Meeting {
    id: number | string;
    title: string;
    host: string;
    status?: string;
    time?: string;
    location?: string;
    dDay?: string;
    date?: string;
    isRegularMeeting?: boolean;
    scheduleStartDateTime?: string;
    scheduleEndDateTime?: string;
}

interface MeetingCardProps {
    meeting: Meeting;
    onClick?: (meeting: Meeting) => void;
    showUpcomingSoonBanner?: boolean;
    timeUntilMeeting?: string | null;
    onLocationClick?: (meetingId: number | string) => void;
}

export const MeetingCard: React.FC<MeetingCardProps> = ({
    meeting,
    onClick,
    showUpcomingSoonBanner = false,
    timeUntilMeeting,
    onLocationClick
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick(meeting);
        }
    };

    const handleBannerClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (onLocationClick) {
            onLocationClick(meeting.id);
        }
    };

    return (
        <div className="home-meeting-card" onClick={handleClick}>
            {/* 1시간 이내 시작하거나 진행 중인 모임 알림 배너 (카드 내부 상단) */}
            {showUpcomingSoonBanner && (
                <div className="meeting-card-upcoming-banner" onClick={handleBannerClick}>
                    <div className="upcoming-banner-icon">📍</div>
                    <div className="upcoming-banner-content">
                        <div className="upcoming-banner-title">
                            {timeUntilMeeting ? `모임 ${timeUntilMeeting} 전입니다` : '모임이 진행 중입니다'}
                        </div>
                        <div className="upcoming-banner-description">
                            위치공유를 선택한 참여자의 위치를 확인하세요
                        </div>
                    </div>
                    <div className="upcoming-banner-arrow">›</div>
                </div>
            )}

            <div className="meeting-card-header">
                <div className="meeting-card-icon">📅</div>
                <div className="meeting-card-info">
                    <div className="meeting-card-title-row">
                        <div className="meeting-card-title">{meeting.title}</div>
                        {meeting.isRegularMeeting && (
                            <div className="meeting-card-regular-badge">🔄 정기</div>
                        )}
                    </div>
                    <div className="meeting-card-host">{meeting.host} 주최</div>
                </div>
                {meeting.status && (
                    <div className={`meeting-card-status status-${meeting.status}`}>
                        {meeting.status}
                    </div>
                )}
                {meeting.dDay && (
                    <div className="meeting-card-dday">{meeting.dDay}</div>
                )}
            </div>
            <div className="meeting-card-details">
                {meeting.time && (
                    <div className="meeting-card-detail">
                        <span className="detail-icon">🕐</span>
                        <span>{meeting.time}</span>
                    </div>
                )}
                {meeting.date && (
                    <div className="meeting-card-detail">
                        <span className="detail-icon">📅</span>
                        <span>{meeting.date}</span>
                    </div>
                )}
                {meeting.location && (
                    <div className="meeting-card-detail">
                        <span className="detail-icon">📍</span>
                        <span>{meeting.location}</span>
                    </div>
                )}
            </div>
        </div>
    );
};
